import React from 'react';

function Footer() {
    return (
        <footer className="footer notification is-warning">
            <div className="content has-text-centered">
                <ul>
                    <li className="no-decoration">GitHub Profile: <a  href="https://github.com/whackingMUFN" target="_blank" rel="noreferrer">Here</a></li>
                    <li className="no-decoration"> || </li>
                    <li className="no-decoration">LinkedIn: <a  href="https://www.linkedin.com/in/calvin-freese-68376a121/">Here </a></li>
                </ul>
            </div>
        </footer>
    )
}

export default Footer;